import React from 'react';
import { Section } from './ui/Section';
export function TableOfContentsSection() {
  const chapters = [{
    num: '01',
    title: 'La verdadera razón por la que pierdes',
    subtitle: '(y no es la técnica)'
  }, {
    num: '02',
    title: 'Las 3 reglas de oro',
    subtitle: 'para eliminar la sobreoperación'
  }, {
    num: '03',
    title: 'Rutina práctica del trader disciplinado',
    subtitle: 'plan de 7 días'
  }, {
    num: '04',
    title: 'Gestión emocional en tiempo real',
    subtitle: 'herramientas rápidas'
  }, {
    num: '05',
    title: 'Plan de sostenibilidad',
    subtitle: 'consistencia 30 días'
  }];
  return <Section background="dark" data-id="element-142">
      <div className="max-w-4xl mx-auto" data-id="element-143">
        <h2 className="text-3xl font-bold text-white text-center mb-12" data-id="element-144">
          Contenido del Ebook
        </h2>

        <div className="space-y-4" data-id="element-145">
          {chapters.map((chapter, index) => <div key={index} className="flex items-center p-6 bg-slate-900 border border-slate-800 rounded-xl hover:border-slate-700 transition-colors" data-id="element-146">
              <span className="text-3xl font-bold text-slate-700 mr-6 font-mono" data-id="element-147">
                {chapter.num}
              </span>
              <div data-id="element-148">
                <h3 className="text-lg md:text-xl font-bold text-white" data-id="element-149">
                  {chapter.title}
                </h3>
                <p className="text-slate-400 text-sm md:text-base" data-id="element-150">
                  {chapter.subtitle}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </Section>;
}